// @flow
import styled from 'styled-components';
import { slide as Menu } from 'react-burger-menu';

import breakpoint from 'styled-components-breakpoint';

import {
  mb, p, m, my, py, mr, mx, mt, px
} from 'styled-components-spacing';

import { fontLink, fontLinkActive } from '@styles/typography';
import theme from '@theme';
import { SearchIcon } from '@images/svg/index';

const { colors, spacing } = theme;

export const StyledSeparator = styled.div`
  border-bottom: solid 1px ${colors.separator};

  ${p(0)}
  ${my(1)}
`;

export const StyledUserNameIcon = styled.div`
  display: flex;
  align-items: center;

  justify-content: center;
`;

export const StyledMobileMenuHeader = styled.div`
  display: block !important;
  flex-direction: column;
  margin-top: 50px;
  outline: none;

  ${m(-3.5)}
  ${mb(2)}
`;

export const StyledUserHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${p(3.5)}
  padding-top: 50px;
  /* @media only screen and (max-width: 320px)  */
  padding-top: 50px;
`;

export const StyledAvatarMain = styled.div`
  width: 210px;
`;
export const StyledMobileMenuBigHeader = styled.div`
  flex-direction: column;
  /* background: linear-gradient(173.68deg, #65a9cd 0%, #64bdd1 99.42%); */
  height: 100vh;
`;

export const StyledAvatar = styled.img.attrs({
  loading: 'lazy'
})`
  width: 120px;
  height: 120px;
  border-radius: 70px;
  background-color: ${colors.translucentWhite};
  object-fit: cover;
  font-family: 'object-fit: cover; object-position: center;';

  ${mb(3)}
  ${breakpoint('tablet', 'desktop')`
  margin-left: 61px;
  `}
  ${breakpoint('mobile', 'desktop')`
    @media only screen and (max-width: 320px) {
      width: 91px;
      height: 91px;   
    }
  `}
`;

export const StyledUserName = styled.p`
  font-size: 24px;
  font-weight: normal;
  text-align: center;
  margin-right: 5px;
  color: ${colors.translucentWhite90};
  ${mb(2)}

  /* svg,
  path {
    fill: ${theme.colors.white};
    stroke: none;
  } */
`;

export const FontMianIcon = styled.p`
  svg,
  path {
    fill: ${theme.colors.white};
    stroke: none;
  }
`;
export const StyledUserMail = styled.div`
  font-size: 16px;
  font-weight: normal;
  color: ${colors.white};
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  
/* 
  & > a {
    color: ${colors.translucentWhite80};
  } */

  & > span {
    width: calc(100% - 25px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 20px;
  }
  ${breakpoint('mobile', 'desktop')`
    @media only screen and (max-width: 340px) {
      padding-left: 1rem;
    }
    @media only screen and (max-width: 310px) {
      padding-left: 2rem;
    }
    @media only screen and (max-width: 290px) {
      padding-left: 2.5rem;
    }
  `}

`;

export const StyledSubMenuLink = styled.div`
  font-weight: 500;
  color: black !important;
  cursor: pointer;
  align-items: flex-end;
  line-height: 35px;
  display: flex;
  justify-content:center;
  border-bottom: 2px solid lightgray;
  ${breakpoint('mobile', 'desktop')`
    @media only screen and (max-width: 340px) {
      font-size: 14px;
      line-height: 27px;
    
    }
  `}

  ${({ isActive }) => (isActive ? fontLinkActive : fontLink)}
  font-weight: ${({ isActive }) => (isActive ? 600 : 500)};
`;

export const StyledCloseSubmenu = styled.p`
  ${py(2.5)}
  ${px(3.5)}
  ${mt(-2)}
  ${mx(-3.5)}
  font-size: 14px;
  color: ${colors.aquaMarine};
  background-color: ${colors.greyBlue10};
  & > *:first-child {
    ${mr(2)}
  }
`;

export const StyledCtaContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  color: white;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: #337a93;
  position: fixed;

  bottom: 0;
  right: 0;

  z-index: 1000;

  ${({ hide }) => hide && 'display: none'};

  ${breakpoint('desktop')`
    display: none;
  `}
`;

export const StyledMenu = styled(Menu)`
  max-width: 500px;
  .bm-item-list {
    padding: 0px !important;
    background: white !important;
  }
`;

export const StyledSubMenuWrapper = styled.div`
  flex-direction: column;
  position: relative;
  display: flex;
  outline: none;
  padding-left: 15%;
  padding-right: 15%;
  justify-content: center;
  & > a,
  & > ${StyledSubMenuLink} {
    ${py(3)}
    ${m(0)}
    display: flex;
    width: 100%;
  }
`;
type Props = {
  heroSection: boolean
};

export const stylesMenu = (props: Props) => ({
  bmBurgerButton: {
    position: 'fixed',
    width: '24px',
    height: '24px',
    right: spacing['3'],
    top: '18px',
    color: props.heroSection ? 'white' : 'black'
  },
  bmBurgerBars: {
    background: colors.darkBlue
  },
  bmBurgerBarsHover: {
    background: colors.aquaMarine
  },
  bmCrossButton: {
    width: '24px',
    height: '24px',
    right: spacing['3'],
    top: spacing['2.5']
  },
  bmCross: {
    color: colors.black
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%'
  },
  bmMenu: {
    background: colors.white,
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%'
  },
  bmItemList: {
    display: 'flex',
    flexDirection: 'column',
    padding: spacing['3.5'],
    boxSizing: 'border-box',
    height: 'auto',
    width: '100%'
  },
  bmItem: {
    display: 'flex'
  },
  bmOverlay: {
    background: colors.translucentDarkBlue
  }
});

export const SearchIconImg = styled(SearchIcon)`
  height: 20px;
`;
